export default {"src":"/_next/static/media/question-mark.352342a7.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};